export default __webpack_public_path__ + "0d5dae46a801d55f8a2eef661765dd5a.svg";